document.addEventListener("DOMContentLoaded", function () {
  // Função para selecionar automaticamente a primeira variação (para 'product-card-item')
  function initializeVariantSelectionForCard() {
    const productCardItems = document.querySelectorAll(".product-card-item"); // Selecione os itens com a classe 'product-card-item'
    if (productCardItems.length) {
      productCardItems.forEach(function (productCardItem) {
        const productOptionsDiv =
          productCardItem.querySelector(".product-options"); // Dentro de cada 'product-card-item'

        if (productOptionsDiv) {
          const productId = productOptionsDiv.getAttribute("data-product-id");

          // Seleciona a primeira variação de cor
          const firstColorInput = productCardItem.querySelector(
            `input[name^="variant-${productId}-1"]`
          );

          if (firstColorInput) {
            firstColorInput.checked = true; // Marca o input de cor como selecionado

            // Encontrar o parent que é o label e disparar o clique
            const colorLabel = firstColorInput.closest("label:not(.unavailable"); // Procura o label mais próximo (caso o input esteja dentro de um label)
            if (colorLabel) {
              colorLabel.click(); // Simula o clique no label
            }
          }

          // Seleciona a primeira variação de tamanho
          const firstSizeInput = productCardItem.querySelector(
            `input[name^="variant-${productId}-2"]`
          );

          /*
          if (firstSizeInput) {
            firstSizeInput.checked = true; // Marca o input de tamanho como selecionado

            // Encontrar o parent que é o label e disparar o clique
            const sizeLabel = firstSizeInput.closest("label:not(.unavailable)"); // Procura o label mais próximo
            if (sizeLabel) {
              //sizeLabel.click(); // Simula o clique no label
            }
          }
          */
        }
      });
    }
  }

  // Inicializa as seleções ao carregar a página
  setTimeout(function () {
    initializeVariantSelectionForCard();
  }, 1000);

  // Delegação de evento para "Adicionar ao Carrinho"
  document.body.addEventListener("click", function (event) {
    if (
      event.target &&
      event.target.matches(".product-card-item .add-to-cart-button")
    ) {
      // Encontre o botão de "Adicionar ao Carrinho" dentro de 'product-card-item'
      const productCardItem = event.target.closest(".product-card-item");
      if (!productCardItem) return; // Verifique se o closest realmente encontrou o elemento
      const productOptionsDiv = productCardItem.querySelector(".product-options");
      if (!productOptionsDiv) {
        console.error("Produto não encontrado para variantes");
        return;
      }
      const productId = productOptionsDiv.getAttribute("data-product-id");

      const size = productCardItem.querySelector(
        `input[name^="variant-${productId}-2"]:checked`
      );
      const color = productCardItem.querySelector(
        `input[name^="variant-${productId}-1"]:checked`
      );

      if (size && color) {
        const selectedSize = size.value;
        const selectedColor = color.value;

        console.log("Tamanho selecionado:", selectedSize);
        console.log("Cor selecionada:", selectedColor);

        const variantsString = productOptionsDiv.getAttribute("data-variants");
        console.log("Variants String:", variantsString);

        let productVariants;
        try {
          productVariants = JSON.parse(variantsString);
          console.log("Variants JSON:", productVariants);
        } catch (e) {
          console.error("Erro ao fazer o parse do JSON:", e);
          return;
        }

        const selectedVariant = productVariants.find(function (variant) {
          return (
            variant.option1 === selectedColor &&
            variant.option2 === selectedSize
          );
        });

        if (selectedVariant) {
          if (selectedVariant.available) {
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: selectedVariant.id,
                    quantity: 1,
                  },
                ],
              }),
            })
              .then((response) => {
                const event = new Event("product:added");
                document.dispatchEvent(event);
              })
              .catch((error) => {
                console.error("Erro ao adicionar ao carrinho:", error);
              });
          } else {
            event.target.disabled = true;
            event.target.classList.add("out-of-stock");

            const variantInputs = productCardItem.querySelectorAll(
              `input[name^="variant-${productId}"]`
            );
            variantInputs.forEach(function (input) {
              const variantId = input.value;
              const variant = productVariants.find(
                (v) => v.option1 === selectedColor && v.option2 === selectedSize
              );
              if (variant && !variant.available) {
                input.parentElement.classList.add("out-of-stock");
              }
            });

            alert("Esta variação está fora de estoque.");
          }
        } else {
          console.error("Seleção inválida de variante");
          alert("Seleção inválida de variante.");
        }
      } else {
        alert("Por favor, selecione uma cor e um tamanho.");
      }
    }
  });

  // Delegação de evento para alterações nos inputs de variante (cor ou tamanho)
  document.body.addEventListener("change", function (event) {
    if (event.target && event.target.matches('input[name^="variant-"]')) {
      // Encontre os inputs de variação
      const productCardItem = event.target.closest(".product-card-item");
      if (!productCardItem) return; // Verifique se o closest realmente encontrou o elemento
      const productId = productCardItem.querySelector(".product-options")
        ? productCardItem.querySelector(".product-options").getAttribute("data-product-id")
        : null;

      if (productId) {
        validateVariantStockForCard(event.target, productId);
      }
    }
  });

  // Função para validar o estoque da variante selecionada (para 'product-card-item')
  function validateVariantStockForCard(input, productId) {
    const productCardItem = input.closest(".product-card-item");
    if (!productCardItem) return; // Verifique se o closest realmente encontrou o elemento

    const size = productCardItem
      ? productCardItem.querySelector(
          `input[name^="variant-${productId}-2"]:checked`
        )
      : null;
    const color = productCardItem
      ? productCardItem.querySelector(
          `input[name^="variant-${productId}-1"]:checked`
        )
      : null;

    if (size && color) {
      const selectedSize = size.value;
      const selectedColor = color.value;

      const productOptionsDiv =
        productCardItem.querySelector(".product-options");
      const variantsString = productOptionsDiv.getAttribute("data-variants");
      let productVariants;
      try {
        productVariants = JSON.parse(variantsString);
      } catch (e) {
        console.error("Erro ao fazer o parse do JSON:", e);
        return;
      }

      if (input.name.includes("-2")) {
        // Se a alteração foi no tamanho
        const colorInputs = productCardItem.querySelectorAll(
          `input[name^="variant-${productId}-1"]`
        );
        colorInputs.forEach((input) => {
          const selectedColor = input.value;
          const variant = productVariants.find(
            (v) => v.option1 === selectedColor && v.option2 === selectedSize
          );
          if (variant) {
            if (variant.available) {
              input.parentElement.classList.remove("out-of-stock");
            } else {
              input.parentElement.classList.add("out-of-stock");
            }
          }
        });
      } else if (input.name.includes("-1")) {
        // Se a alteração foi na cor
        const sizeInputs = productCardItem.querySelectorAll(
          `input[name^="variant-${productId}-2"]`
        );
        sizeInputs.forEach((input) => {
          const selectedSize = input.value;
          const variant = productVariants.find(
            (v) => v.option1 === selectedColor && v.option2 === selectedSize
          );
          if (variant) {
            if (variant.available) {
              input.parentElement.classList.remove("out-of-stock");
            } else {
              input.parentElement.classList.add("out-of-stock");
            }
          }
        });
      }
    }
  }
});
